import { render } from "./NoveltiesCardsComp.vue?vue&type=template&id=081709ed&scoped=true&ts=true"
import script from "./NoveltiesCardsComp.vue?vue&type=script&lang=ts"
export * from "./NoveltiesCardsComp.vue?vue&type=script&lang=ts"

import "./NoveltiesCardsComp.vue?vue&type=style&index=0&id=081709ed&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\user\\Documents\\Code\\VSProjects\\modboxProject\\modbox\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-081709ed"]])

export default __exports__